<template>
    <div class="asset-img-section" :class="{'has-many': list && list.length > 1, 'is-loading': list && list.length > 1 && !listLoaded, 'is-fallback': isFallback}" :id="id" @click="click">
        <img :src="currentSrc" :class="{imgClassName}" v-if="currentSrc">
        <div v-if="currentList && currentList.length > 1" class="anim-thumbs d-flex" :class="{'is-loading': !listLoaded, 'anim-thumbs-3d': asset && asset.asset_type === '3D'}">
            <div class="hover-block" v-for="(t,i) in currentList" :key="i">
                <img :src="t" :class="imgClassName" v-show="listLoaded">
            </div>
        </div>
        <div class="loader-block" v-if="list && list.length > 1 && !listLoaded">
            <div class="loading">
                <div class="effect-1 effects"></div>
                <div class="effect-2 effects"></div>
                <div class="effect-3 effects"></div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "HoverThumb",
        props: {
            onClick: Function,
            id: String,
            imgClassName: String,
            main: String,
            list: Array,
            mainWebp: String,
            listWebp: {
                type: Array,
                default: () => []
            },
            smMain: String,
            smMainWebp: String,
            asset: {
                type: Object,
                default: () => {}
            },
            ignoreList: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isFallback: false,
                currentSrc: '',
                currentList: [],
                small: false,
                source: false,
                withTransition: true,
                smUrl: '',
                listLoaded: 0
            }
        },
        computed: {
            componentName: () => {
                return "HoverThumb"
            }
        },
        mounted() {
            // this.preloadImage('smMain').then(res => {
            //     if (res) {
            //         this.currentSrc = res;
            //     }
            //     this.preloadImage('main').then(res => {
            //         if (res) {
            //             this.currentSrc = res;
            //         }
            //         if (this.list && this.list.length > 1) {
            //             Promise.all(this.list.map((item, index) => this.preloadImage('list', index))).then(res => {
            //                 this.listLoaded = true;
            //                 this.currentList = res;
            //             })
            //         }
            //     })
            // })
            this.handleMainImg().then(res => {
                if (!this.ignoreList) {
                    this.handleListImg();
                } else {
                    if (!this.listLoaded) {
                        this.listLoaded = true;
                    }
                }
            })
            // this.preloadImage('main').then(res => {
            //     if (res) {
            //         this.currentSrc = res;
            //     }
            //     if (this.list && this.list.length > 1) {
            //         Promise.all(this.list.map((item, index) => this.preloadImage('list', index))).then(res => {
            //             this.listLoaded = true;
            //             this.currentList = res;
            //         })
            //     }
            // })
        },
        methods: {
            handleMainImg() {
                return new Promise(resolve => {
                    this.preloadImage('main').then(res => {
                        this.isFallback = res.match(/default-thumbs/);
                        if (res && (!this.asset || !this.asset.thumbnail || this.asset.thumbnail === res || this.asset.thumbnail.match(/cooboamp.s3/) || this.isFallback)) {
                            this.currentSrc = res;
                        }
                        resolve();
                    })
                });
            },
            handleListImg() {
                let asset = this.asset;
                return new Promise(resolve => {
                    if (this.list && this.list.length > 1) {
                        this.listLoaded = false;
                        Promise.all(this.list.map((item, index) => this.preloadImage('list', index))).then(res => {
                            if (!this.asset || asset === this.asset) {
                                this.listLoaded = true;
                                this.currentList = res;
                            }

                            resolve();
                        })
                    } else {
                        resolve();
                    }
                })
            },
            preloadImage(propName, index) {
                let webpEl = ((index || index == 0) ? this[propName + 'Webp'][index] : this[propName + 'Webp']);
                webpEl = false;
                if (this.$store.state.supportWebp && webpEl) {
                    return this.preloadWebp(webpEl);
                } else {
                    let el = ((index || index == 0) ? this[propName][index] : this[propName]);
                    if (!el && propName == 'main' && this.list && this.list[0]) {
                        el = this.list[0];
                    }
                    return this.preloadNoWebp(el ? el : this.$root.getDefaultThumbnail(this.asset ? this.asset.asset_type: '')).then(r => {
                      return r ? r : this.$root.getDefaultThumbnail(this.asset ? this.asset.asset_type: '')
                    })
                }
            },
            fixUrl(url) {
              if (url.match(/cooboamp.s3/)) {
                url = url.replace('https://cooboamp.s3.ap-southeast-1.amazonaws.com', 'https://stembibecooboamp.blob.core.windows.net/cooboamp')
                if (url.match(/\/\/tmp/i)) {
                  url = url.replace(/\/tmp/i, 'tmp')
                }
              }

              return url;
            },
            preloadWebp(url) {
                return new Promise(resolve => {
                  url = this.fixUrl(url);
                  let webpUrl = url + ".webp";
                  let tempImg = new Image();
                  tempImg.onload = () => {
                      resolve(url);
                  };
                  tempImg.onerror = () => {
                      this.preloadNoWebp(url).then(res => {
                          resolve(res)
                      })
                  };
                  tempImg.src = webpUrl;
                })
            },
            preloadNoWebp(url) {
                return new Promise(resolve => {
                  url = this.fixUrl(url);
                  let webpUrl = url;
                  let tempImg = new Image();
                  tempImg.onload = () => {
                      resolve(url);
                  };
                  tempImg.onerror = () => {
                      resolve(false);
                  };
                  tempImg.src = webpUrl;
                })
            },
            click() {
                if (typeof this.onClick === "function") {
                    this.onClick()
                }
            },
        },
        watch: {
            main(next, prev) {
                if (next !== prev) {
                    this.currentSrc = '';
                    this.currentList = [];

                    this.handleMainImg().then(res => {
                        if (!this.ignoreList) {
                            this.handleListImg();
                        } else {
                            if (!this.listLoaded) {
                                this.listLoaded = true;
                            }
                        }
                    })
                }
            },
            list(next, prev) {
                // let isEqual = next.length === prev.length && next.every((value, index) => value === prev[index])
                // if (!isEqual) {
                //     console.log(2)
                //     this.currentList = [];
                //     this.handleListImg();
                // }
            }
        },
    }
</script>


<style scoped>
    .loader-block {
        left: 0;
        top: 0;
    }
    .is-loading {
        pointer-events: none;
    }
</style>
